import store from '../store'
import Vue from 'vue'
import moment from 'moment'

export const EventBus = new Vue()

export class Utils {
  static cleanUsername (username) {
    return username
      .trim()
      .toLowerCase()
      .replace(/[\W_]+/g, '.')
      .replace(/^[^A-Z]+|[^A-Z0-9]+$/ig, '')
  }

  static usernameToEmail (username) {
    return `${this.cleanUsername(username)}@${store.getters.emailDomain}`
  }

  static getBlankComment () {
    return {
      timestamp: moment().unix(),
      user: `${store.getters.user.firstName} ${store.getters.user.lastName}`,
      usedId: store.getters.user.uid,
      msg: ''
    }
  }

  static isSameDay (date1, date2) {
    return date1.format('DD-MM-YYY') === date2.format('DD-MM-YYY')
  }

  static camelToSpaces (str, uppercase = true) {
    let spacesStr = str.replace(/([A-Z])/g, ' $1')
    if (uppercase) {
      spacesStr = spacesStr.replace(/^./, (s) => {
        return s.toUpperCase()
      })
    }
    return spacesStr
  }

  static timeStrToMoment (timeStr, dayMoment) {
    let arr = timeStr.split(' ')
    if (arr.length !== 2) {
      return false
    }
    arr = arr[0].split(':')
    if (arr.length !== 2) {
      return false
    }
    let hours = Number(arr[0])
    let mins = Number(arr[1])
    if (hours < 1 || hours > 12 || mins < 0 || mins > 59) {
      return false
    }

    let dateTimeString = `${dayMoment.format('DD/MM/YYYY')} ${timeStr}`
    return moment(dateTimeString, 'DD/MM/YYYY hh:mm a')
  }

  static clone (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  static docToObj (doc) {
    if (!doc || !doc.exists) {
      return false
    }
    let obj = doc.data()
    obj._id = doc.id
    return obj
  }

  static snapshotToArr (snapshot) {
    if (!snapshot || !snapshot.docs) {
      return false
    }

    return snapshot.docs.map(doc => {
      let data = doc.data()
      data._id = doc.id
      return data
    })
  }

  static snapshotToObjMap (snapshot, filter) {
    if (!snapshot || !snapshot.docs) {
      return false
    }

    let obj = {}
    for (let doc of snapshot.docs) {
      let data = doc.data()
      data._id = doc.id
      if (this.filter(data, filter)) {
        obj[doc.id] = data
      }
    }
    return obj
  }

  static applyFilters (data, filters = []) {
    for (let filter of filters) {
      if (!this.filter(data, filter)) {
        return false
      }
    }
    return true
  }

  static filter (data, filter) {
    if (!filter || filter.value === null || filter.value === undefined) return true
    let dataValue = data[filter.key]
    switch (filter.operator) {
      case '==':
        return dataValue == filter.value // eslint-disable-line
      case '===':
        return dataValue === filter.value
      case '!=':
        return dataValue != filter.value // eslint-disable-line
      case '!===':
        return dataValue !== filter.value
      case '<':
        return dataValue < filter.value
      case '<=':
        return dataValue <= filter.value
      case '>':
        return dataValue > filter.value
      case '>=':
        return dataValue >= filter.value
      case 'contains':
        return `${dataValue}`.toLowerCase().indexOf(`${filter.value}`.toLowerCase()) >= 0
      case 'custom':
        return filter.filter(data, filter.value)
      default:
        return true
    }
  }

  static snapshotToObj (snapshot) {
    let data = false
    if (snapshot) {
      if (snapshot.docs && snapshot.docs.length) {
        data = snapshot.docs[0].data()
        data._id = snapshot.docs[0].id
      } else if (snapshot.exists) {
        data = snapshot.data()
        data._id = snapshot.id
      }
    }
    return data
  }

  static createShortUUID (length = 10) {
    var dt = new Date().getTime()
    let uuid = ''
    for (let i = 0; i < length; i++) uuid += 'x'
    return uuid.replace(/[x]/g, c => {
      let r = (dt + Math.random() * 16) % 16 | 0
      dt = Math.floor(dt / 16)
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  }
}
